export * from '@taqueria/protocol/out/types/NetworkConfig';
